import axios from 'axios';

const API_BASE_URL = 'https://localhost:44366';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ejemplo de GET
const getItems = async () => {
  try {
    const response = await api.get('/obtenerPublicaciones');
    return response.data;
  } catch (error) {
    console.error('Error al obtener items:', error);
    throw error;
  }
};



export default {
  getItems
};